/**
 * Viewfinder preferences — SESSION ONLY (SPEC_STAMP_ROUND_20260924 §D: "memory only, no persistence,
 * no telemetry"). One value today: whether the rule-of-thirds grid + level are shown on premises
 * stills. Default ON. A page reload forgets it; nothing here touches storage or the wire.
 */

import { useSyncExternalStore } from 'react';

let gridOn = true;
const listeners = new Set<() => void>();

export function isGridOn(): boolean {
  return gridOn;
}

export function setGridOn(next: boolean): void {
  if (gridOn === next) return;
  gridOn = next;
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

/** The grid toggle as React state, shared by every viewfinder in the session. */
export function useGridOn(): readonly [boolean, (next: boolean) => void] {
  const on = useSyncExternalStore(subscribe, isGridOn, isGridOn);
  return [on, setGridOn];
}

export function resetViewfinderPrefsForTests(): void {
  gridOn = true;
}
